import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBSeparator } from '@shared/components/list/separator';
import { Styles } from '../styles';
import { MBUserImage, MBUserImageProps } from './profile';

export interface MBUserCollageProps {
  /*
        Array of profile pictures of users in a channel. These
        will be displayed in a grid depending on the amount of urls.
    */
  users: MBAPI.ShortUser[];

  size?: 'normal' | 'small';

  style?: StyleProp<ViewStyle>;
}

/*
    A rounded image which shows multiple pictures in a grid.
*/
export function MBUserCollage({
  users,
  size = 'normal',
  style: styleOverride,
}: MBUserCollageProps) {
  const style: StyleProp<ViewStyle> = [
    size === 'small' && Styles.userSmall,
    size === 'normal' && Styles.userNormal,
    size === 'small' && Styles.collageSmall,
    size === 'normal' && Styles.collageNormal,
    styleOverride,
  ];

  const smallerSize: MBUserImageProps['size'] = (() => {
    if (size === 'small') {
      return 'tiny';
    }
    if (size === 'normal') {
      return 'small';
    }
    return 'small';
  })();

  if (users.length === 0) {
    return <MBView fill style={style} />;
  }

  if (users.length === 1) {
    return (
      <MBView style={style}>
        <MBUserImage user={users[0]} />
      </MBView>
    );
  }

  if (users.length === 2) {
    return (
      <MBView row style={style}>
        <MBUserImage user={users[0]} size={size} />
        <MBSeparator vertical />
        <MBUserImage user={users[1]} size={size} />
      </MBView>
    );
  }

  if (users.length === 3) {
    return (
      <MBView row style={style}>
        <MBUserImage size={size} user={users[0]} />
        <MBSeparator vertical />
        <View fill>
          <MBUserImage user={users[1]} size={smallerSize} />
          <MBSeparator />
          <MBUserImage user={users[2]} size={smallerSize} />
        </View>
      </MBView>
    );
  }

  // if we have 4 or more images
  return (
    <MBView row style={style}>
      <View fill>
        <MBUserImage user={users[0]} size={smallerSize} />
        <MBSeparator />
        <MBUserImage user={users[1]} size={smallerSize} />
      </View>
      <MBSeparator vertical />
      <View fill>
        <MBUserImage user={users[2]} size={smallerSize} />
        <MBSeparator />
        <MBUserImage user={users[3]} size={smallerSize} />
      </View>
    </MBView>
  );
}
